import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../../services/portalApi';
import { useAuth } from '../../context/AuthContext';
import AuthCard from '../../components/AuthCard';

export default function ChangePassword({ firstTime }) {
  const { clearPasswordReset } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onFinish = async ({ currentPassword, newPassword, confirm }) => {
    if (newPassword !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await authApi.changePassword(currentPassword, newPassword);
      clearPasswordReset();
      message.success('Password updated');
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard>
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        {firstTime ? 'Set a new password' : 'Change password'}
      </Typography.Title>
      {firstTime && (
        <Typography.Paragraph type="secondary">
          For security, please replace your temporary password before continuing.
        </Typography.Paragraph>
      )}
      {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} showIcon />}
      <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
        <Form.Item name="currentPassword" label="Current password" rules={[{ required: true }]}>
          <Input.Password size="large" autoComplete="current-password" />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="New password"
          rules={[{ required: true, min: 8, message: 'At least 8 characters' }]}
        >
          <Input.Password size="large" autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="confirm" label="Confirm new password" rules={[{ required: true }]}>
          <Input.Password size="large" autoComplete="new-password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" size="large" block loading={loading}>
          Update password
        </Button>
      </Form>
    </AuthCard>
  );
}
